import React from "react";
import "./notApplicable.scss";
import { getNotApplicableMessage } from "constants/constants";
import { project } from "utils/enums";
function NotApplicable({ children, projectname }) {
  return (
    <>
      {projectname === project.BO ||projectname === project.PO? (
        <h6 className="unauth">{getNotApplicableMessage(projectname)}</h6>
      ) : (
        <>{children}</>
      )}
    </>
  );
}

export default NotApplicable;
